<template>
    <div class="bento-container">
        <!-- Page Header -->
        <div class="bento-header">
            <div class="header-content">
                <div class="header-icon">
                    <i class="el-icon-user"></i>
                </div>
                <div class="header-text">
                    <h2>讲师中心</h2>
                    <p>讲师管理 · 讲师信息管理</p>
                </div>
            </div>
            <div class="header-actions">
                <div class="header-search">
                    <div class="search-input-wrapper">
                        <el-select v-model="formDatas.selectedCategoryIds" multiple collapse-tags placeholder="讲师分类"
                            size="medium" class="ai-input category-select" style="width: 180px;" @change="partserch"
                            clearable>
                            <el-option v-for="item in categoryOptions" :key="item.value" :label="item.label"
                                :value="item.value" />
                        </el-select>
                    </div>
                </div>
                <div class="header-search">
                    <div class="search-input-wrapper">
                        <i class="el-icon-search input-icon"></i>
                        <el-input v-model="formDatas.searchKey" placeholder="搜索关键词" clearable size="medium"
                            class="ai-input" @keyup.enter.native="partserch"></el-input>
                    </div>
                </div>
                <el-button class="ai-btn" @click="partserch">
                    <i class="el-icon-search"></i>
                    搜索
                </el-button>
                <el-button class="ai-btn secondary" @click="exportToFile">
                    <i class="el-icon-s-promotion"></i>
                    导出讲师
                </el-button>
                <el-button class="ai-btn secondary" @click="importToFile">
                    <i class="el-icon-upload"></i>
                    导入讲师
                </el-button>
                <el-button class="ai-btn secondary" @click="addForm">
                    <i class="el-icon-plus"></i>
                    新增讲师
                </el-button>
            </div>
        </div>

        <!-- Bento Grid Layout -->
        <div class="bento-grid">
            <div class="bento-card table-card full">
                <div class="card-header">
                    <span class="card-title">
                        <i class="el-icon-notebook-2"></i>
                        讲师列表
                    </span>
                    <div class="card-actions">
                        <span class="ai-hint">
                            <i class="el-icon-info"></i>
                            讲师信息管理
                        </span>
                    </div>
                </div>
                <div class="card-content">
                    <aj-table ref="ajTable" :data="tableData" :columns="tableColumns" :editable="tableEditable"
                        :use-internal-pagination="true" :currentPage.sync="formDatas.currentPage" :height="tableHeight"
                        :pageSize.sync="formDatas.pageSize" :total="totalCount" row-id-key="teacherId" stripe
                        @page-change="handlePageChange" @operate-btn-click="handleOperateBtnClick"
                        @selection-change="handleSelectionChange" @update:checkedIds="updateCheckedIds">
                        <template #cell-teacherHeader="{ row }">
                            <el-image v-if="row.teacherHeader" style="width: 40px; height: 40px; border-radius: 8px;"
                                :src="row.teacherHeader"></el-image>
                            <span v-else class="no-avatar">-</span>
                        </template>
                        <template #cell-teacherType="{ row }">
                            <el-tag
                                :type="row.teacherType === 1 ? 'danger' : row.teacherType === 2 ? 'success' : 'primary'"
                                size="small" effect="plain">
                                {{ row.teacherType === 1 ? '内部' : row.teacherType === 2 ? '外部' : '独家' }}
                            </el-tag>
                        </template>
                    </aj-table>
                </div>
            </div>
        </div>

        <!-- Dialogs -->
        <aj-form-add ref="add_lecturer" :formConfig="formConfig" :formData="form" :dialogVisible="addDialogVisible"
            dialogTitle="新增讲师信息" dialogWidth="1000px" formSize="small" cancelText="关闭" confirmText="提交新增"
            @confirm="handleAddConfirm" @update:dialogVisible="val => addDialogVisible = val" labelWidth="150px"
            @item-change="handleItemChange">
        </aj-form-add>
        <aj-form-edit ref="edit_lecturer" :formConfig="formConfig" :formData="form" :dialogVisible="editDialogVisible"
            @update:dialogVisible="val => editDialogVisible = val" dialogTitle="编辑讲师信息" labelWidth="150px"
            @confirm="handleEditConfirm" dialogWidth="1000px">
        </aj-form-edit>
        <!-- 批量导入弹窗 -->
        <batch-import-dialog ref="importDialog" :visible.sync="importDialogVisible" title="批量导入讲师基本信息"
            dialog-width="900px" upload-url="/ajTeacher/uploadAjTeacher"
            template-url="https://equityappsub.aojuai.com/aicourse/excel/teacherExcelIn.xlsx" template-btn-text="下载导入模板"
            template-text="讲师基本信息模板" accept-hint="xlsx、xls" :fail-columns="importFailColumns" fail-table-title="导入失败数据"
            :use-internal-pagination="true" :page-size="10" @upload-success="handleImportSuccess" />
        <!-- 讲师详情弹窗 -->
        <teacher-detail-dialog ref="teacherDetailDialog" :teacher-id="currentTeacherId" dialog-title="讲师详情" />

        <!-- 讲师协议弹窗 -->
        <el-dialog title="讲师协议" :visible.sync="jsxyDialogVisible" width="800px" append-to-body>
            <div class="dialog-header">
                <el-button type="primary" @click="handleJsxyAdd" size="small">新增协议</el-button>
            </div>
            <el-table :data="jsxyTableData" border style="width: 100%" max-height="400">
                <el-table-column prop="ataTitle" label="协议名称" align="center"></el-table-column>
                <el-table-column prop="ataPath" label="协议地址" align="center">
                    <template slot-scope="scope">
                        <template v-if="scope.row.ataPath">
                            <template v-for="(fileUrl, index) in parseVideoPaths(scope.row.ataPath)">
                                <a v-if="fileUrl" :key="index" :href="fileUrl" target="_blank"
                                    style="color: #409EFF; margin-right: 10px;">查看协议{{ index + 1 }}</a>
                            </template>
                        </template>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="ataDate" label="协议日期" align="center"></el-table-column>
                <el-table-column label="操作" width="150" align="center">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="handleJsxyEdit(scope.row)">编辑</el-button>
                        <el-button size="mini" type="danger" @click="handleJsxyDelete(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-wrapper">
                <el-pagination @current-change="handleJsxyPageChange" :current-page="1" :page-size="10"
                    layout="total, prev, pager, next" :total="jsxyTotalCount">
                </el-pagination>
            </div>
        </el-dialog>

        <!-- 试讲视频弹窗 -->
        <el-dialog title="试讲视频" :visible.sync="sjspDialogVisible" width="800px" append-to-body>
            <div class="dialog-header">
                <el-button type="primary" @click="handleSjspAdd" size="small">新增视频</el-button>
            </div>
            <el-table :data="sjspTableData" border style="width: 100%" max-height="400">
                <el-table-column prop="atctTitle" label="视频名称" align="center"></el-table-column>
                <el-table-column prop="atctPath" label="视频地址" align="center">
                    <template slot-scope="scope">
                        <template v-if="scope.row.atctPath">
                            <template v-for="(videoUrl, index) in parseVideoPaths(scope.row.atctPath)">
                                <a v-if="videoUrl" :key="index" :href="videoUrl" target="_blank"
                                    style="color: #409EFF; margin-right: 10px;">查看视频{{ index + 1 }}</a>
                            </template>
                        </template>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="atctDate" label="拍摄日期" align="center"></el-table-column>
                <el-table-column prop="atctDes" label="备注" align="center"></el-table-column>
                <el-table-column label="操作" width="150" align="center">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="handleSjspEdit(scope.row)">编辑</el-button>
                        <el-button size="mini" type="danger" @click="handleSjspDelete(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-wrapper">
                <el-pagination @current-change="handleSjspPageChange" :current-page="1" :page-size="10"
                    layout="total, prev, pager, next" :total="sjspTotalCount">
                </el-pagination>
            </div>
        </el-dialog>

        <!-- 授课记录弹窗 -->
        <el-dialog title="授课记录" :visible.sync="skjlDialogVisible" width="800px" append-to-body>
            <div class="dialog-header">
                <el-button type="primary" @click="handleSkjlAdd" size="small">新增记录</el-button>
            </div>
            <el-table :data="skjlTableData" border style="width: 100%" max-height="400">
                <el-table-column prop="atchUnit" label="授课单位" align="center"></el-table-column>
                <el-table-column prop="atchTitle" label="课程名称" align="center"></el-table-column>
                <el-table-column prop="atchDate" label="授课时间" align="center"></el-table-column>
                <el-table-column prop="atchStar" label="评分" align="center">
                    <template slot-scope="scope">
                        <el-rate v-model="scope.row.atchStar" disabled show-score text-color="#ff9900"></el-rate>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="150" align="center">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="handleSkjlEdit(scope.row)">编辑</el-button>
                        <el-button size="mini" type="danger" @click="handleSkjlDelete(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-wrapper">
                <el-pagination @current-change="handleSkjlPageChange" :current-page="1" :page-size="10"
                    layout="total, prev, pager, next" :total="skjlTotalCount">
                </el-pagination>
            </div>
        </el-dialog>

        <!-- 新增/编辑协议弹窗 -->
        <aj-form-add ref="jsxyAddForm" :formConfig="jsxyFormConfig" :formData="jsxyFormData"
            :dialogVisible="jsxyAddVisible" dialogTitle="新增协议" @confirm="handleJsxyAddConfirm"
            @update:dialogVisible="val => jsxyAddVisible = val" labelWidth="100px">
        </aj-form-add>
        <aj-form-edit ref="jsxyEditForm" :formConfig="jsxyFormConfig" :formData="jsxyFormData"
            :dialogVisible="jsxyEditVisible" dialogTitle="编辑协议" @confirm="handleJsxyEditConfirm"
            @update:dialogVisible="val => jsxyEditVisible = val" labelWidth="100px">
        </aj-form-edit>

        <!-- 新增/编辑视频弹窗 -->
        <aj-form-add ref="sjspAddForm" :formConfig="sjspFormConfig" :formData="sjspFormData"
            :dialogVisible="sjspAddVisible" dialogTitle="新增视频" @confirm="handleSjspAddConfirm"
            @update:dialogVisible="val => sjspAddVisible = val" labelWidth="100px">
        </aj-form-add>
        <aj-form-edit ref="sjspEditForm" :formConfig="sjspFormConfig" :formData="sjspFormData"
            :dialogVisible="sjspEditVisible" dialogTitle="编辑视频" @confirm="handleSjspEditConfirm"
            @update:dialogVisible="val => sjspEditVisible = val" labelWidth="100px">
        </aj-form-edit>

        <!-- 新增/编辑记录弹窗 -->
        <aj-form-add ref="skjlAddForm" :formConfig="skjlFormConfig" :formData="skjlFormData"
            :dialogVisible="skjlAddVisible" dialogTitle="新增记录" @confirm="handleSkjlAddConfirm"
            @update:dialogVisible="val => skjlAddVisible = val" labelWidth="100px">
        </aj-form-add>
        <aj-form-edit ref="skjlEditForm" :formConfig="skjlFormConfig" :formData="skjlFormData"
            :dialogVisible="skjlEditVisible" dialogTitle="编辑记录" @confirm="handleSkjlEditConfirm"
            @update:dialogVisible="val => skjlEditVisible = val" labelWidth="100px">
        </aj-form-edit>
    </div>
</template>

<script>
import {
    getAjTeacherListOperation, 
    addAjTeacher,
    updateAjTeacher,
    deleteAjTeacher,
    getAjTeacherClassList,
    getAjTeacherLabelList,
    getAjUserListTeacherCharge,
    getAjTeacherDetails,
    exportFile,
    getAjTeacherAgreementList,
    addAjTeacherAgreement,
    updateAjTeacherAgreement,
    deleteAjTeacherAgreement,
    getAjTeacherCourseTrailList,
    addAjTeacherCourseTrail,
    updateAjTeacherCourseTrail,
    deleteAjTeacherCourseTrail,
    getAjTeacherCourseHistoryList,
    addAjTeacherCourseHistory,
    updateAjTeacherCourseHistory,
    deleteAjTeacherCourseHistory
} from "../../api/api";
import qs from 'qs';
// 导入批量导入组件
import BatchImportDialog from '@/components/ajForm/ajBatchImport.vue';
// 导入讲师详情弹框组件
import TeacherDetailDialog from '@/components/page_components/TeacherDetailDialog.vue';
// 导入表单弹窗组件
import AjFormAdd from '@/components/ajForm/ajFormAdd.vue';
import AjFormEdit from '@/components/ajForm/ajFormEdit.vue';
export default {
    components: {
        BatchImportDialog,
        TeacherDetailDialog,
        AjFormAdd,
        AjFormEdit
    },
    name: "lecturer",
    data() {
        return {
            userPost: null,
            tableHeight: 500,
            importFailColumns: [
                { type: 'index', label: '序号', width: 60, align: 'center' },
                { label: '状态', prop: 'status', width: 90 },
                { label: '失败原因', prop: 'statusMsg', width: 120 },
                { label: '排序', prop: 'teacherOrder', width: 120, align: 'center', },
                { label: '讲师姓名', prop: 'teacherName', width: 120, align: 'center', },
                { label: '讲师类型', prop: 'teacherType', width: 100, align: 'center' },
                { label: '讲师价格', prop: 'teacherPrice', width: 100, align: 'center' },
                { label: '擅长课程', prop: 'teacherCourseTalent', width: 150, align: 'center' },
                { label: '常驻地', prop: 'teacherAddress', width: 120, align: 'center' },
                { label: '联系电话', prop: 'contactPhone', width: 130, align: 'center' },
                { label: '联系邮箱', prop: 'contactEmail', width: 180, align: 'center' },
                { label: '讲师负责人', prop: 'auName', width: 100, align: 'center' },
            ],
            importDialogVisible: false,
            addDialogVisible: false,
            editDialogVisible: false,
            // 讲师协议弹窗
            jsxyDialogVisible: false,
            jsxyCurrentTeacherId: null,
            jsxyTableData: [],
            jsxyTotalCount: 0,
            jsxyFormData: { ataTitle: '', ataPath: '', ataDate: '' },
            jsxyFormConfig: [
                [{ type: 'input', label: '协议名称', prop: 'ataTitle', placeholder: '请输入协议名称', span: 24, required: true }],
                [{ type: 'upload', label: '协议文件', prop: 'ataPath', span: 24, acceptType: '.pdf,.doc,.docx', limit: 1, uploadBtnText: '上传协议文件', showLimitInfo: true }],
                [{ type: 'date', label: '协议日期', prop: 'ataDate', placeholder: '请选择协议日期', span: 24, required: false, dateType: 'date', valueFormat: 'yyyy-MM-dd' }],
            ],
            jsxyAddVisible: false,
            jsxyEditVisible: false,
            jsxyEditId: null,
            // 试讲视频弹窗
            sjspDialogVisible: false,
            sjspCurrentTeacherId: null,
            sjspTableData: [],
            sjspTotalCount: 0,
            sjspFormData: { atctTitle: '', atctPath: '', atctDate: '', atctDes: '' },
            sjspFormConfig: [
                [{ type: 'input', label: '视频名称', prop: 'atctTitle', placeholder: '请输入视频名称', span: 24, required: true }],
                [{ type: 'upload', label: '试讲视频', prop: 'atctPath', span: 24, acceptType: '.mp4,.avi,.mov,.flv', limit: 1, maxFileSize: 500 * 1024 * 1024, uploadBtnText: '上传视频', showLimitInfo: true }],
                [{ type: 'date', label: '拍摄日期', prop: 'atctDate', placeholder: '请选择拍摄日期', span: 24, required: false, dateType: 'date', valueFormat: 'yyyy-MM-dd' }],
                [{ type: 'input', label: '备注', prop: 'atctDes', placeholder: '请输入备注', span: 24, required: false }],
            ],
            sjspAddVisible: false,
            sjspEditVisible: false,
            sjspEditId: null,
            // 授课记录弹窗
            skjlDialogVisible: false,
            skjlCurrentTeacherId: null,
            skjlTableData: [],
            skjlTotalCount: 0,
            skjlFormData: { atchUnit: '', atchTitle: '', atchDate: '', atchStar: '' },
            skjlFormConfig: [
                [{ type: 'input', label: '授课单位', prop: 'atchUnit', placeholder: '请输入授课单位', span: 24, required: true }],
                [{ type: 'input', label: '课程名称', prop: 'atchTitle', placeholder: '请输入课程名称', span: 24, required: false }],
                [{ type: 'date', label: '授课时间', prop: 'atchDate', placeholder: '请选择授课时间', span: 24, required: false, dateType: 'date', valueFormat: 'yyyy-MM-dd' }],
                [{ type: 'input', label: '评分', prop: 'atchStar', placeholder: '请输入评分', span: 24, required: false, inputType: 'number' }],
            ],
            skjlAddVisible: false,
            skjlEditVisible: false,
            skjlEditId: null,
            currentTeacherId: null, // 当前查看详情的讲师ID
            form: {},
            formConfig: [],
            totalCount: 0,
            tableData: [],
            categoryOptions: [], // 讲师分类选项
            labelOptions: [], // 讲师标签选项
            chargePersonOptions: [], // 讲师负责人选项
            tableColumns: [
                { type: 'selection', label: '', width: 80, fixed: 'left', align: 'center' },
                { label: '排序', prop: 'teacherOrder', width: 100, align: 'center', fixed: 'left' },
                { label: '讲师姓名', prop: 'teacherName', width: 120, align: 'center', fixed: 'left' },
                {
                    label: '讲师头像', prop: 'teacherHeader', width: 100, align: 'center',
                    formatter: (row) => row.teacherHeader ? `<img src="${row.teacherHeader}" style="width:40px;height:40px;border-radius:50%;">` : '-'
                },
                { label: '讲师编码', prop: 'teacherNumber', width: 120, align: 'center' },
                { label: '职位头衔', prop: 'teacherPosition', width: 150, align: 'center' },
                {
                    label: '讲师类型', prop: 'teacherType', width: 100, align: 'center',
                    formatter: (row) => {
                        const typeMap = { 1: '内部', 2: '外部', 3: '独家' };
                        return typeMap[row.teacherType] || '-';
                    }
                },
                { label: '讲师分类', prop: 'atcNames', width: 150, align: 'center' },
                { label: '讲师标签', prop: 'atlNames', width: 150, align: 'center' },
                { label: '身份证号', prop: 'teacherIdcard', width: 180, align: 'center' },
                { label: '讲师价格', prop: 'teacherPrice', width: 100, align: 'center' },
                { label: '价格区间', prop: 'teacherPriceRange', width: 120, align: 'center' },
                { label: '擅长课程', prop: 'teacherCourseTalent', width: 150, align: 'center' },
                { label: '常驻地', prop: 'teacherAddress', width: 120, align: 'center' },
                { label: '联系电话', prop: 'contactPhone', width: 130, align: 'center' },
                { label: '联系邮箱', prop: 'contactEmail', width: 180, align: 'center' },
                { label: '联系微信', prop: 'contactWechat', width: 150, align: 'center' },
                { label: '讲师负责人', prop: 'auName', width: 100, align: 'center' },
                { label: '创建时间', prop: 'createtime', width: 180, align: 'center' },
                {
                    type: 'operation',
                    label: '操作',
                    prop: 'operation',
                    fixed: 'right',
                    width: 400,
                    buttons: [
                        { key: 'detail', text: '详情', icon: 'el-icon-view' },
                        { key: 'edit', text: '编辑', icon: 'el-icon-edit' },
                        { key: 'delete', text: '删除', icon: 'el-icon-delete' },
                        { key: 'jsxy', text: '讲师协议', icon: 'el-icon-document' },
                        { key: 'sjsp', text: '试讲视频', icon: 'el-icon-video-camera' },
                        { key: 'skjl', text: '授课记录', icon: 'el-icon-date' }
                    ]
                }
            ],
            tableEditable: false,

            formDatas: {
                teacherName: '',
                selectedCategoryIds: [],
                currentPage: 1,
                pageSize: 20,
            },
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight;
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        this.userPost = window.localStorage.getItem('zhikeTong_userPost');
        this.getCategoryOptions();
        this.getLabelOptions();
        this.getChargePersonOptions();
        this.partserch();
    },
    mounted() {
        // 初始化表格高度
        this.handleResize()
        // 监听窗口大小变化
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        /**
       * 窗口大小变化时更新表格高度
       */
        handleResize() {
            this.$nextTick(() => {
                const cardContent = this.$el.querySelector('.card-content');
                this.tableHeight = this.$utils.getContainerAvailableHeight(cardContent, { extraOffset: 100 });
                console.log(this.tableHeight);

            });
        },
        /**
         * 解析视频地址，返回数组
         */
        parseVideoPaths(pathStr) {
            if (!pathStr) return [];
            try {
                const parsed = JSON.parse(pathStr);
                return Array.isArray(parsed) ? parsed : [parsed];
            } catch (e) {
                return [];
            }
        },
        updateCheckedIds(ids) {
            console.log(ids);
            this.tableCheckIds = ids;
        },
        // 导入成功回调
        handleImportSuccess(data) {
            console.log('🎉 handleImportSuccess 被调用，导入成功:', data);
            console.log('🎉 成功数据条数:', data.successData ? data.successData.length : 0);
            // 刷新列表
            this.partserch();
            this.$message.success(`导入成功，共 ${data.successData ? data.successData.length : 0} 条数据`);
        },
        importToFile() {
            this.importDialogVisible = true;
        },
        async exportToFile() {
            if (!this.tableCheckIds || this.tableCheckIds.length === 0) {
                this.$message.warning('请先选择要导出的讲师信息');
                return;
            }
            try {
                this.$loading.show()
                // 使用 qs 序列化参数，确保 POST 表单数据正确传递
                const params = qs.stringify({ teacherIds: JSON.stringify(this.tableCheckIds) });
                await exportFile('/ajTeacher/exportAjTeacher', params, '讲师');
                this.$refs.ajTable.clearSelection();
                this.$loading.close()
            } catch (error) {
                console.error('导出失败:', error);
            }
        },
        // 获取讲师分类选项
        getCategoryOptions() {
            getAjTeacherClassList({}).then(res => {
                if (res.status === 200) {
                    const list = res.data || [];
                    this.categoryOptions = list.map(item => ({
                        label: item.atcName,
                        value: item.atcId
                    }));
                }
            });
        },
        // 获取讲师标签选项
        getLabelOptions() {
            getAjTeacherLabelList({}).then(res => {
                if (res.status === 200) {
                    const list = res.data || [];
                    this.labelOptions = list.map(item => ({
                        label: item.atlName,
                        value: item.atlId
                    }));
                }
            });
        },
        // 获取讲师负责人选项
        getChargePersonOptions() {
            getAjUserListTeacherCharge().then(res => {
                if (res.status === 200) {
                    const list = res.data || [];
                    this.chargePersonOptions = list.map(item => ({
                        label: item.auName,
                        value: item.auId
                    }));
                }
            });
        },
        // 表单配置项
        getFormInit() {
            this.formConfig = [
                [{ type: 'input', label: '讲师姓名', prop: 'teacherName', placeholder: '请输入讲师姓名', span: 12, required: true }],
                [{ type: 'input', label: '身份证号', prop: 'teacherIdcard', placeholder: '请输入身份证号', span: 12, required: false }],
                [{ type: 'upload', label: '讲师头像', prop: 'teacherHeader', acceptType: 'image/*,application/pdf', limit: 1, multiple: false, placeholder: '请输入头像地址', span: 12, required: false }],
                [{ type: 'input', label: '职位头衔', prop: 'teacherPosition', placeholder: '请输入职位头衔', span: 12, required: false }],
                [{
                    type: 'select', label: '讲师类型', prop: 'teacherType', placeholder: '请选择讲师类型', span: 12, required: false,
                    options: [{ label: '内部', value: 1 }, { label: '外部', value: 2 }, { label: '独家', value: 3 }]
                }, { type: 'input', label: '联系电话', prop: 'contactPhone', placeholder: '请输入联系电话', span: 12, required: false }],

                [{ type: 'input', label: '联系邮箱', prop: 'contactEmail', placeholder: '请输入联系邮箱', span: 12, required: false },
                { type: 'input', label: '联系微信', prop: 'contactWechat', placeholder: '请输入联系微信', span: 12, required: false }],
                [{
                    type: 'select', label: '讲师分类', prop: 'atcIds', placeholder: '请选择讲师分类', span: 12, required: false,
                    options: this.categoryOptions, filterable: true, multiple: true,
                },
                {
                    type: 'select', label: '讲师标签', prop: 'atlIds', placeholder: '请选择讲师标签(可多选)', span: 12, required: false,
                    options: this.labelOptions, multiple: true, filterable: true
                }],
                [{ type: 'input', label: '讲师价格', prop: 'teacherPrice', placeholder: '请输入讲师价格', span: 12, required: false, inputType: 'number' },
                { type: 'input', label: '价格区间', prop: 'teacherPriceRange', placeholder: '请输入价格区间', span: 12, required: false }],
                [{ type: 'input', label: '擅长课程', prop: 'teacherCourseTalent', placeholder: '请输入擅长课程', span: 24, required: false }],
                [{ type: 'input', label: '常驻地', prop: 'teacherAddress', placeholder: '请输入常驻地', span: 12, required: false },
                { type: 'input', label: '排序', prop: 'teacherOrder', placeholder: '请输入排序', span: 12, required: false }],
                [{
                    type: 'select', label: '讲师负责人', prop: 'auId', placeholder: '请选择讲师负责人', span: 24, required: false,
                    options: this.chargePersonOptions, filterable: true, showCondition: () => this.userPost != 3
                }],
                [{ type: 'upload', label: '简介附件1', prop: 'teacherIntroductionFileOne', acceptType: 'image/*,application/pdf', limit: 1, multiple: false, span: 24, required: false }],
                [{ type: 'upload', label: '简介附件2', prop: 'teacherIntroductionFileTwo', acceptType: 'image/*,application/pdf', limit: 1, multiple: false, span: 24, required: false }],
                [{ type: 'textarea', label: '讲师简介', prop: 'teacherIntroduction', placeholder: '请输入讲师简介', span: 24, required: false, rows: 4 }],
            ];
            this.form = {
                teacherName: '',
                teacherIdcard: '',
                teacherHeader: '',
                teacherPosition: '',
                teacherType: '',
                contactPhone: '',
                contactEmail: '',
                contactWechat: '',
                atcIds: '',
                atlIds: [],
                teacherPrice: '',
                teacherPriceRange: '',
                teacherCourseTalent: '',
                teacherAddress: '',
                auId: '',
                teacherIntroductionFileOne: [],
                teacherIntroductionFileTwo: [],
                teacherIntroduction: '',
            };
        },
        // 编辑提交
        async handleEditConfirm({ data }) {
            console.log('编辑提交：', data);
            try {
                await this.$confirmDialog({
                    content: '确认编辑该讲师吗？',
                    type: 'success'
                });
                const newData = JSON.parse(JSON.stringify(data));
                newData.atlIds = newData.atcIds ? JSON.stringify(newData.atcIds) : '';
                newData.teacherHeader = data.teacherHeader.length > 0 ? data.teacherHeader[0] : '';
                newData.atcIds = newData.atcIds ? JSON.stringify(newData.atcIds) : '';
                newData.teacherIntroductionFileOne = data.teacherIntroductionFileOne.length > 0 ? data.teacherIntroductionFileOne[0] : '';
                newData.teacherIntroductionFileTwo = data.teacherIntroductionFileTwo.length > 0 ? data.teacherIntroductionFileTwo[0] : '';
                updateAjTeacher(newData).then(res => {
                    if (res.status == 200) {
                        this.$message.success('编辑成功');
                        this.$refs.edit_lecturer.cancelDiaLog();
                        this.partserch();
                    } else {
                        this.$message.error(res.msg || '编辑失败');
                    }
                });
            } catch {
                // this.$message.error('取消');
            }
        },
        // 表单项变更监听
        handleItemChange({ prop, value, type }) {
            console.log(`【${type}】${prop} 变更为：`, value);
        },
        // 新增提交
        async handleAddConfirm({ data }) {
            try {
                await this.$confirmDialog({
                    content: '确认新增该讲师吗？',
                    type: 'success'
                });
                const newData = JSON.parse(JSON.stringify(data));
                newData.atlIds = newData.atcIds ? JSON.stringify(newData.atcIds) : '';
                newData.teacherHeader = data.teacherHeader.length > 0 ? data.teacherHeader[0] : '';
                newData.atcIds = newData.atcIds ? JSON.stringify(newData.atcIds) : '';
                newData.teacherIntroductionFileOne = data.teacherIntroductionFileOne.length > 0 ? data.teacherIntroductionFileOne[0] : '';
                newData.teacherIntroductionFileTwo = data.teacherIntroductionFileTwo.length > 0 ? data.teacherIntroductionFileTwo[0] : '';
                addAjTeacher(newData).then(res => {
                    if (res.status === 200) {
                        this.$message.success('新增成功');
                        this.$refs.add_lecturer.cancelDiaLog();
                        this.partserch();
                    } else {
                        this.$message.error(res.msg || '新增失败');
                    }
                });
            } catch {
                // this.$message.error('取消');
            }
        },

        addForm() {
            this.getFormInit();
            this.addDialogVisible = true;
        },

        // 分页切换回调
        handlePageChange({ currentPage, pageSize }) {
            console.log('分页切换：', `第${currentPage}页，每页${pageSize}条`);
            this.formDatas.currentPage = currentPage;
            this.formDatas.pageSize = pageSize;
            this.getListData();
        },

        // 操作按钮点击回调
        handleOperateBtnClick({ btn, row }) {
            switch (btn.key) {
                case 'detail':
                    this.handleDetail(row);
                    break;
                case 'edit':
                    this.handleEdit(row);
                    break;
                case 'delete':
                    this.handleDelete(row);
                    break;
                case 'jsxy':
                    this.handleJsxy(row);
                    break;
                case 'sjsp':
                    this.handleSjsp(row);
                    break;
                case 'skjl':
                    this.handleSkjl(row);
                    break;
            }
        },
        // 详情操作
        handleDetail(row) {
            this.currentTeacherId = row.teacherId;
            this.$refs.teacherDetailDialog.open();
        },
        // 选中状态变化回调
        handleSelectionChange(selRows) {
            // console.log('当前页选中行：', selRows.map(row => row.teacherId));
        },
        // 编辑操作
        async handleEdit(row) {
            this.getFormInit();
            try {
                const res = await getAjTeacherDetails({ teacherId: row.teacherId });
                if (res.status === 200) {
                    const data = res.data || {};
                    const s = JSON.parse(JSON.stringify(data));
                    s.teacherHeader = data.teacherHeader ? [data.teacherHeader] : [];
                    s.atcIds = data.ajTeacherClassRelationList ? data.ajTeacherClassRelationList.map(item => item.atcId) : [];
                    s.atlIds = data.ajTeacherLabelRelationList ? data.ajTeacherLabelRelationList.map(item => item.atlId) : [];
                    s.teacherIntroductionFileOne = data.teacherIntroductionFileOne ? [data.teacherIntroductionFileOne] : [];
                    s.teacherIntroductionFileTwo = data.teacherIntroductionFileTwo ? [data.teacherIntroductionFileTwo] : [];

                    this.form = s;
                    this.editDialogVisible = true;
                }
            } catch (error) {
                console.error('获取讲师详情失败:', error);
            }
        },
        // 删除操作
        async handleDelete(row) {
            try {
                await this.$confirmDialog({
                    content: '确认删除该讲师吗？',
                    type: 'danger'
                });
                deleteAjTeacher({ teacherId: row.teacherId }).then(res => {
                    if (res.status === 200) {
                        this.$message.success('删除成功');
                        this.partserch();
                    } else {
                        this.$message.error(res.msg || '删除失败');
                    }
                });
            } catch {
                // this.$message.error('取消');
            }
        },

        // 获取列表数据
        getListData() {
            const params = { ...this.formDatas };
            // 添加讲师分类筛选条件
            if (params.selectedCategoryIds && params.selectedCategoryIds.length > 0) {
                params.atcIds = JSON.stringify(params.selectedCategoryIds);
            }
            delete params.selectedCategoryIds; // 删除临时字段
            getAjTeacherListOperation(params).then((res) => {
                if (res.status === 200) {
                    this.tableData = res.data || [];
                    this.totalCount = res.total || 0;
                }
            });
        },

        partserch() {
            this.formDatas.currentPage = 1;
            this.getListData();
        },
        resetSearch() {
            this.formDatas.teacherName = '';
            this.formDatas.selectedCategoryIds = [];
            this.partserch();
        },

        // ==================== 讲师协议 ====================
        // 打开讲师协议弹窗
        handleJsxy(row) {
            this.jsxyCurrentTeacherId = row.teacherId;
            this.jsxyDialogVisible = true;
            this.getJsxyList();
        },
        // 获取讲师协议列表
        getJsxyList(page = 1) {
            const params = {
                teacherId: this.jsxyCurrentTeacherId,
                currentPage: page,
                pageSize: 10
            };
            getAjTeacherAgreementList(params).then(res => {
                if (res.status === 200) {
                    this.jsxyTableData = res.data || [];
                    this.jsxyTotalCount = res.total || 0;
                }
            });
        },
        // 分页
        handleJsxyPageChange(page) {
            this.getJsxyList(page);
        },
        // 新增协议
        handleJsxyAdd() {
            this.jsxyFormData = { ataTitle: '', ataPath: '', ataDate: '' };
            this.jsxyAddVisible = true;
        },
        // 新增协议确认
        handleJsxyAddConfirm({ data }) {
            const params = {
                teacherId: this.jsxyCurrentTeacherId,
                ...data
            };
             params.ataPath = params.ataPath ? JSON.stringify(params.ataPath) : '';
            addAjTeacherAgreement(params).then(res => {
                if (res.status === 200) {
                    this.$message.success('新增成功');
                    this.$refs.jsxyAddForm.cancelDiaLog();
                    this.getJsxyList();
                } else {
                    this.$message.error(res.msg || '新增失败');
                }
            });
        },
        // 编辑协议
        handleJsxyEdit(row) {
            this.jsxyFormData = {
                ataTitle: row.ataTitle,
                ataPath: row.ataPath?JSON.parse(row.ataPath):[],
                ataDate: row.ataDate
            };
            this.jsxyEditId = row.ataId;
            this.jsxyEditVisible = true;
        },
        // 编辑协议确认
        handleJsxyEditConfirm({ data }) {
            const params = {
                teacherId: this.jsxyCurrentTeacherId,
                ataId: this.jsxyEditId,
                ...data
            };
              params.ataPath = params.ataPath ? JSON.stringify(params.ataPath) : '';
            updateAjTeacherAgreement(params).then(res => {
                if (res.status === 200) {
                    this.$message.success('编辑成功');
                    this.$refs.jsxyEditForm.cancelDiaLog();
                    this.getJsxyList();
                } else {
                    this.$message.error(res.msg || '编辑失败');
                }
            });
        },
        // 删除协议
        async handleJsxyDelete(row) {
            try {
                await this.$confirmDialog({
                    content: '确认删除该协议吗？',
                    type: 'danger'
                });
                deleteAjTeacherAgreement({ ataId: row.ataId }).then(res => {
                    if (res.status === 200) {
                        this.$message.success('删除成功');
                        this.getJsxyList();
                    } else {
                        this.$message.error(res.msg || '删除失败');
                    }
                });
            } catch { }
        },

        // ==================== 试讲视频 ====================
        // 打开试讲视频弹窗
        handleSjsp(row) {
            this.sjspCurrentTeacherId = row.teacherId;
            this.sjspDialogVisible = true;
            this.getSjspList();
        },
        // 获取试讲视频列表
        getSjspList(page = 1) {
            const params = {
                teacherId: this.sjspCurrentTeacherId,
                currentPage: page,
                pageSize: 10
            };
            getAjTeacherCourseTrailList(params).then(res => {
                if (res.status === 200) {
                    this.sjspTableData = res.data || [];
                    this.sjspTotalCount = res.total || 0;
                }
            });
        },
        // 分页
        handleSjspPageChange(page) {
            this.getSjspList(page);
        },
        // 新增视频
        handleSjspAdd() {
            this.sjspFormData = { atctTitle: '', atctPath: '', atctDate: '', atctDes: '' };
            this.sjspAddVisible = true;
        },
        // 新增视频确认
        handleSjspAddConfirm({ data }) {
            const params = {
                teacherId: this.sjspCurrentTeacherId,
                ...data
            };
            params.atctPath = params.atctPath ? JSON.stringify(params.atctPath) : '';
            addAjTeacherCourseTrail(params).then(res => {
                if (res.status === 200) {
                    this.$message.success('新增成功');
                    this.$refs.sjspAddForm.cancelDiaLog();
                    this.getSjspList();
                } else {
                    this.$message.error(res.msg || '新增失败');
                }
            });
        },
        // 编辑视频
        handleSjspEdit(row) {
            this.sjspFormData = {
                atctTitle: row.atctTitle,
                atctPath: row.atctPath ? JSON.parse(row.atctPath):[],
                atctDate: row.atctDate,
                atctDes: row.atctDes
            };
            this.sjspEditId = row.atctId;
            this.sjspEditVisible = true;
        },
        // 编辑视频确认
        handleSjspEditConfirm({ data }) {
            const params = {
                teacherId: this.sjspCurrentTeacherId,
                atctId: this.sjspEditId,
                ...data
            };
              params.atctPath = params.atctPath ? JSON.stringify(params.atctPath) : '';
            updateAjTeacherCourseTrail(params).then(res => {
                if (res.status === 200) {
                    this.$message.success('编辑成功');
                    this.$refs.sjspEditForm.cancelDiaLog();
                    this.getSjspList();
                } else {
                    this.$message.error(res.msg || '编辑失败');
                }
            });
        },
        // 删除视频
        async handleSjspDelete(row) {
            try {
                await this.$confirmDialog({
                    content: '确认删除该视频吗？',
                    type: 'danger'
                });
                deleteAjTeacherCourseTrail({ atctId: row.atctId }).then(res => {
                    if (res.status === 200) {
                        this.$message.success('删除成功');
                        this.getSjspList();
                    } else {
                        this.$message.error(res.msg || '删除失败');
                    }
                });
            } catch { }
        },

        // ==================== 授课记录 ====================
        // 打开授课记录弹窗
        handleSkjl(row) {
            this.skjlCurrentTeacherId = row.teacherId;
            this.skjlDialogVisible = true;
            this.getSkjlList();
        },
        // 获取授课记录列表
        getSkjlList(page = 1) {
            const params = {
                teacherId: this.skjlCurrentTeacherId,
                currentPage: page,
                pageSize: 10
            };
            getAjTeacherCourseHistoryList(params).then(res => {
                if (res.status === 200) {
                    this.skjlTableData = res.data || [];
                    this.skjlTotalCount = res.total || 0;
                }
            });
        },
        // 分页
        handleSkjlPageChange(page) {
            this.getSkjlList(page);
        },
        // 新增记录
        handleSkjlAdd() {
            this.skjlFormData = { atchUnit: '', atchTitle: '', atchDate: '', atchStar: '' };
            this.skjlAddVisible = true;
        },
        // 新增记录确认
        handleSkjlAddConfirm({ data }) {
            const params = {
                teacherId: this.skjlCurrentTeacherId,
                ...data
            };
            addAjTeacherCourseHistory(params).then(res => {
                if (res.status === 200) {
                    this.$message.success('新增成功');
                    this.$refs.skjlAddForm.cancelDiaLog();
                    this.getSkjlList();
                } else {
                    this.$message.error(res.msg || '新增失败');
                }
            });
        },
        // 编辑记录
        handleSkjlEdit(row) {
            this.skjlFormData = {
                atchUnit: row.atchUnit,
                atchTitle: row.atchTitle,
                atchDate: row.atchDate,
                atchStar: row.atchStar || ''
            };
            this.skjlEditId = row.atchId;
            this.skjlEditVisible = true;
        },
        // 编辑记录确认
        handleSkjlEditConfirm({ data }) {
            const params = {
                teacherId: this.skjlCurrentTeacherId,
                atchId: this.skjlEditId,
                ...data
            };
            updateAjTeacherCourseHistory(params).then(res => {
                if (res.status === 200) {
                    this.$message.success('编辑成功');
                    this.$refs.skjlEditForm.cancelDiaLog();
                    this.getSkjlList();
                } else {
                    this.$message.error(res.msg || '编辑失败');
                }
            });
        },
        // 删除记录
        async handleSkjlDelete(row) {
            try {
                await this.$confirmDialog({
                    content: '确认删除该记录吗？',
                    type: 'danger'
                });
                deleteAjTeacherCourseHistory({ atchId: row.atchId }).then(res => {
                    if (res.status === 200) {
                        this.$message.success('删除成功');
                        this.getSkjlList();
                    } else {
                        this.$message.error(res.msg || '删除失败');
                    }
                });
            } catch { }
        },
    },
};
</script>

<style scoped>
/* Bento Grid Layout */
.bento-container {
    padding: 15px 20px;
    min-height: 100%;
    background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
}

/* Page Header */
.bento-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    padding: 20px 24px;
    background: white;
    border-radius: 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.1);
}

.header-content {
    display: flex;
    align-items: center;
    gap: 16px;
}

.header-icon {
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
    border-radius: 12px;
    color: white;
    font-size: 24px;
}

.header-text h2 {
    margin: 0;
    font-size: 20px;
    font-weight: 600;
    color: #1e293b;
}

.header-text p {
    margin: 4px 0 0;
    font-size: 13px;
    color: #64748b;
}

.header-actions {
    display: flex;
    align-items: center;
    gap: 16px;
}

.header-search {
    flex: 1;
    max-width: 300px;
}

.header-search:first-child {
    max-width: 200px;
}

/* AI Button Styles */
.ai-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 10px 20px;
    border: none;
    border-radius: 10px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    background: linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%);
    color: white;
    box-shadow: 0 4px 14px rgba(14, 165, 233, 0.4);
}

.ai-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(14, 165, 233, 0.5);
}

.ai-btn.secondary {
    background: white;
    color: #64748b;
    border: 1px solid #e2e8f0;
    box-shadow: none;
}

.ai-btn.secondary:hover {
    background: #f8fafc;
    border-color: #cbd5e1;
}

/* Bento Grid */
.bento-grid {
    grid-template-columns: 1fr;
    gap: 20px;
}

/* Bento Card */
.bento-card {
    background: white;
    border-radius: 16px;
    padding: 20px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.1);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.bento-card:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.bento-card.full {
    width: 100%;
}

.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid #f1f5f9;
}

.card-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 15px;
    font-weight: 600;
    color: #1e293b;
}

.card-title i {
    color: #8b5cf6;
}

.ai-hint {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    color: #94a3b8;
    padding: 4px 10px;
    background: #f5f3ff;
    border-radius: 20px;
}

/* Search Card */
.search-card {
    grid-column: span 1;
}

.search-row {
    display: flex;
    gap: 12px;
    align-items: center;
}

.search-input-wrapper {
    flex: 1;
    position: relative;
}

.input-icon {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #94a3b8;
    z-index: 1;
}

.ai-input ::v-deep .el-input__inner {
    padding-left: 36px;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    background: #f8fafc;
    transition: all 0.3s;
}

.ai-input ::v-deep .el-input__inner:focus {
    border-color: #0ea5e9;
    background: white;
    box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.1);
}

.category-select ::v-deep .el-input__inner {
    padding-left: 12px;
}

.category-select ::v-deep .el-select__tags {
    max-width: 120px !important;
}

.category-select ::v-deep .el-tag {
    max-width: 80px;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* Table Card */
.table-card {
    width: 100%;
    min-height: 400px;
}

.card-content {
    padding: 4px 0;
}

/* Scrollbar */
.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}

/* Responsive */
@media (max-width: 768px) {
    .bento-header {
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
    }

    .header-actions {
        width: 100%;
        flex-wrap: wrap;
    }

    .header-search {
        max-width: 100%;
        flex: 1;
    }
}

/* Dialog styles */
.dialog-header {
    margin-bottom: 16px;
    text-align: right;
}

.pagination-wrapper {
    margin-top: 16px;
    text-align: right;
}

.el-table {
    margin-top: 10px;
}
</style>
